<template>
  <div
    class="modal fade"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit" ref="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group text-left">
                      <label class="label-required">ผล LAB:</label>
                      <textarea
                        placeholder="ผล LAB"
                        class="form-control"
                        id="labResult"
                        name="labResult"
                        ref="labResult"
                        v-model="labResult"
                        :disabled="!isEdit"
                        rows="7"
                        :maxlength="maxLength"
                      ></textarea>
                      <span class="form-text"></span>
                      <span style="float: right" v-if="labResult">{{ labResult.length}} / {{ maxLength }}</span>
                      <span style="float: right" v-if="!labResult || labResult==''">0 / {{ maxLength }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group text-left">
                      <label>ไฟล์:</label>
                      <button
                        type="button"
                        class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-4"
                        :id="'uploader-order' + _uid"
                        :data-ref="_uid"
                      >
                        <i class="flaticon-upload-1"></i>เลือกไฟล์
                      </button>
                      <!-- <button
                        v-if="IsShowUploadBtn"
                        type="button"
                        class="btn btn-success m-btn--pill btn-block col-xl-4"
                        @click.prevent="UploadFile"
                      >
                        <i class="fas fa-cloud-upload-alt"></i>อัพโหลดไฟล์
                      </button> -->
                      <div class="row" :id="'container-file' + _uid"></div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="formReset()"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> {{ bnt }}
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import plupload from "plupload";

export default {
  data: function() {
    return {
      title: "ระบุผลการวิเคราะห์น้ำเบียร์",
      labResult: null,
      isEdit: true,
      bnt: "บันทึก",
      maxLength: 330,
      uuid: null,
      File: [],
      FileCount: 0,
    };
  },
  methods: {
    formReset: function() {
      let self = this;
      var $imageContainer = $("#container-file" + self.uuid);
      if ($("#files", $imageContainer).data("file-id") != null) {
        $imageContainer.empty();
      }
    },
    formSubmit: function(e) {
      e.preventDefault();

      let self = this;
      if (
        !$(self.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      //ระบุผลการวิเคราะห์
      // let status = "CLAIM_STATUS_BEER_ANALYZE_SPECIFY";
      // if (
      //   self.$parent.data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_SPECIFY"
      // ) {
      //   //ส่งผลการวิเคราะห์
      //   status = "CLAIM_STATUS_BEER_ANALYZE_RESULT";
      // }

      // ส่งผลการวิเคราะห์
      let status = "CLAIM_STATUS_BEER_ANALYZE_RESULT";

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังเปลี่ยนสถานะเบียร์เคลม กรุณารอสักครู่...",
      });

      // $(".btm-remove-img-beerclaim").each(function() {
      //   var $img = $(this);
      //   var file = {
      //     FileID : $img.data("file-newid"),
      //     FileName : null,
      //     FileDescription : null,
      //   };
      //   self.File.push(file);
      // });

      // if (self.File.length > 0) {
      //   $("#files").each(function(e) {
      //     console.log(e);
      //     var $img = $(this);
      //     console.log($img);
      //     self.File[e].FileName = $img.data("file-name");
      //   });
      // }

      axios
        .put("/Api/BeerClaim/EditStatus", {
          ClaimItemId: self.$parent.data.claimItemId,
          StatusCode: status,
          LabResult: self.labResult,
          File: self.File
        })
        .then(function(response) {
          if (response.data.status) {
            self.$parent.$parent.reloadDataTable();

            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $(self.$el).modal("hide");
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    deleteImg() {
      let self = this;
      self.uuid = this._uid;
      $("#container-file" + self.uuid).on("click", ".btm-remove-img-beerclaim", function(e) {
        e.preventDefault();
        var $img = $(this);
        Swal.fire({
          title: "ยืนยันคำสั่ง",
          text: "คุณต้องการลบไฟล์นี้หรือไม่",
          icon: "danger",
          confirmButtonText:
            "<span><i class='la la-check'></i><span>ฉันต้องการลบไฟล์นี้</span></span>",
          confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",

          showCancelButton: true,
          cancelButtonText:
            "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
          cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon",

          // imageUrl: Setting.rootPath + "uploads/" + $img.data("file-newid"),
          imageWidth: 400,
          imageAlt: "Custom image",
          buttons: true,
          dangerMode: true,
        }).then(function(result) {
          let file = $img.data("file-newid");
          // let url = Setting.rootPath + "Api/File/DeleteFile/" + file;
          let url = "/Api/File/DeleteFile/" + file;
          if (result.value) {
            if ($img.data("type") != "1") {
              $.ajax({
                type: "Get",
                url: url,
                cache: false,
                success: function(response) {
                  var fileId = "#" + $img.data("file-id");
                  $(fileId).remove();
                  Swal.fire("เรียบร้อย!", "ลบไฟล์เรียบร้อย", "success");
                },
                failure: function(response) {
                  swal(
                    "Internal Error",
                    "Oops, your note was not saved.", // had a missing comma
                    "error"
                  );
                },
              });
            } else {
              var fileId = "#" + $img.data("file-id");
              $(fileId).remove();
              Swal.fire("เรียบร้อย!", "ลบไฟล์เรียบร้อย", "success");
            }
          }
        });
      });
    },
    initPlUploader() {
      let self = this;
      self.uuid = this._uid;
      // console.log(self.uuid);

      var uploader = new plupload.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        //multi_selection: false,
        browse_button: "uploader-order" + self.uuid, // you can pass in id...
        //url: Setting.rootPath + "Components/Plupload?reference=" + self.uuid, // คือ Url มาตรฐานของ plupload
        url: "/Components/Plupload?reference=" + self.uuid,

        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "1024mb",
          mime_types: [
            {
              title: "doc files",
              extensions: "jpg,jpeg,png,pdf,xlsx,xls,doc,docx,mp4,avi,ppt,pptx",
            },
          ],
        },
        //resize: {
          //width: 300,
          //quality: 100,
        //},
        init: {
          PostInit: function() {
          },

          FilesAdded: function(up, files) {
            self.FileCount = files.length;

            if (self.FileCount > 5)
            {
              Swal.fire("ขออภัย", "แนบไฟล์มากสุด 5 ไฟล์", "warning");
            }
            else
            {
              self.File = [];
              var $uploadBtn = $(up.settings.browse_button[0]);
              var $imageContainer = $("#container-file" + self.uuid);
              //mApp.block($imageContainer.parents('.m-portlet__body'))

              if ($("#files", $imageContainer).data("file-id") != null) {
                $(".btm-remove-img-beerclaim").each(function() {
                  var $img = $(this);
                  var file = $img.data("file-newid");
                  let url = "/Api/File/DeleteFile/" + file;
                  $.ajax({
                    type: "Get",
                    url: url,
                    cache: false,
                    success: function(response) {
                      //console.log("FilesAdded pass");
                    },
                    failure: function(response) {
                      Swal.fire(
                        "Internal Error",
                        "Oops, your note was not saved.", // had a missing comma
                        "error"
                      );
                    },
                  });
                });
                $imageContainer.empty();
              }

              var removeFiles = [];
              plupload.each(files, function(file) {
                if ($('div[data-file-name="' + file.name + '"]', $imageContainer).length == 0) {
                  console.log(file.id);
                  var nativeData = file.getNative();
                  if (typeof FileReader != "undefined") {
                    var image_holder = $('<div class="col-md-12 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' + file.id + '"></div>');

                    $(
                      '<div style="display:none" id="files" data-file-id="' +
                        file.id +
                        '" data-file-name="' +
                        file.name +
                        '" data-file-uploaded="false" alt="' +
                        file.name +
                        '">' +
                        file.name +
                        '<div id="myProgress" class=" progress' +
                        file.id +
                        '"><div id="myBar' +
                        // file.id +
                        '" class="progress-bar bg-success"><b></b></div ></div></div>'
                    ).appendTo(image_holder);

                    image_holder.appendTo($imageContainer);
                    
                    var reader = new FileReader();
                    reader.onload = function(e) {
                      $("div[data-file-id=" + file.id + "]")
                        .attr("src", e.target.result)
                        .show();
                    };
                    reader.readAsDataURL(nativeData);
                  }
                }
                else {
                  removeFiles.push(file);
                }
              });

              if (removeFiles.length > 0) {
                for (var i = 0; i < removeFiles.length; i++) {
                  up.removeFile(removeFiles[i]);
                }

                Swal.fire("ขออภัย", "ไม่สามารถเลือกไฟล์ซ้ำได้", "warning");
              }

              up.start();
            }
          },

          // BeforeUpload: function(up, file) {
          //   check_object_radio();
          //   set_upload_param(up, file.name, true);
          // },

          UploadProgress: function(up, file) {
            // console.log("UploadProgress");
            // console.log(file);
            document
              .getElementById(file.id)
              .getElementsByTagName("b")[0].innerHTML =
              "<span>" + file.percent + "%</span>";
            $("#myBar" + file.id + " .progress-bar .bg-success").css(
              "width",
              file.percent - 1 + "%"
            );
          },

          FileUploaded: function(up, file, info) {
            // console.log("FileUploaded");
            if (info.response == "OK") {
              // console.log("OK");
              var $uploadBtn = $(up.settings.browse_button[0]);
              var $imageContainer = $("#container-file" + self.uuid);
              var $img = $("div[data-file-id=" + file.id + "]");
              $img.attr("data-file-uploaded", "true");
              //var url = Setting.rootPath + "Api/File/MoveFile";
              var url = "/Api/File/MoveFile";
              var ref = $("#uploader-order" + self.uuid).data("ref");
              $.ajax({
                url: url,
                type: "post",
                data: {
                  FileID: $img.data("file-id"),
                  FileName: $img.data("file-name"),
                  Reference: ref,
                },
                datatype: "json",
                ContentType: "application/json;utf-8",
              }).done(function(data) {
                // console.log("done");
                var File = {
                  FileID : data.fileName,
                  FileName : file.name,
                  FileDescription : null,
                };
                self.File.push(File);

                /*ถ้าสำเร็จให้ทำอะไรต่อ */
                $("#myBar" + file.id).remove();
                // $(
                //   '<div id="myBar' +
                //     //file.id +
                //     '" class="progress-bar bg-success" style="width:100%"><b>100%</b></div >'
                // ).appendTo($(".progress" + file.id));

                $(
                  '<a href="javascript:;" style="position:absolute;top: 20px;right: 20px;padding-left: 5px;padding-top: 0px;padding-right: 5px;padding-bottom: 0px;" class="btn m-btn--pill btn-danger m-btn btm-remove-img-beerclaim close" data-file-newid="' +
                    data.fileName +
                    '" data-file-id="' +
                    file.id +
                    '" ><span class="m--font-inverse-danger la la-trash"></span></a>'
                ).appendTo("#" + data.fileID);

                $(
                  '<div id="newid" data-file-newid="' + data.fileName + '"></div>'
                ).appendTo("#" + data.fileID);

                // $("#" + file.id).removeClass(
                //   "kt-spinner kt-spinner--lg kt-spinner--warning"
                // );
                
                $("#" + file.id).add;
              });
            }
          },

          Error: function(up, err) {
            // console.log("Error");
            // console.log(err.file.id);
            $("#myBar" + err.file.id).remove();
            $(
              '<div id="myBar' +
                err.file.id +
                '" class="myBar" style="background-color:red;width:100%"><b>false</b></div >'
            ).appendTo($(".progress" + err.file.id));
            $("#" + err.file.id).removeClass(
              "kt-spinner kt-spinner--lg kt-spinner--warning"
            );
            var a = $(
              '<a class="btn m-btn--pill btn-info m-btn btm-reload-img-beerclaim"><span class="fas fa-redo-alt"></span></a>'
            );
            a.appendTo("#" + err.file.id);
            a.data("up", up);
            a.data("file", err.file);
            a.click(function() {
              var $this = $(this);
              var myUp = $this.data("up");
              var myFile = $this.data("file");
              myFile.status = plupload.QUEUED;
              $("#" + myFile.id).remove();
              myUp.addFile(myFile);
            });
            var d = $(
              '<a class="btn m-btn--pill btn-danger m-btn btm-delete-img-beerclaim" style="position:absolute;top:10px;right:20px;"><span class="far fa-trash-alt"></span></a>'
            );
            d.appendTo("#" + err.file.id);
            d.click(function() {
              $("#" + err.file.id).remove();
            });
          },
        },
      });
      uploader.init();
    },
  },
  mounted() {
    let self = this;

    self.initPlUploader();
    self.deleteImg();

    //กรณี ส่งผลการวิเคราะห์
    // if (
    //   self.$parent.data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_SPECIFY"
    // ) {
    //   //console.log(self.$parent.data.claimItemId);
    //   //console.log(self.$parent.data.labResult);
    //   self.labResult = self.$parent.data.labResult;
    //   self.title = "ส่งผลการวิเคราะห์";
    //   self.isEdit = false;
    //   self.bnt = "ยืนยัน";
    // }

    $(self.$refs.form).validate({
      rules: {
        labResult: "required",
      },
      messages: {
        labResult: "กรุณากรอกผลแลบ",
      },
    });

    $(self.$el).on("hidden.bs.modal", function() {
      $(self.$refs.labResult)
        .val("")
        .trigger("change");
    });
  },
};
</script>

<style lang="scss" scoped>
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-beerclaim {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-beerclaim {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-beerclaim {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1.2rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/BeerClaim/AnalyzeSpecifyForm.vue